import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const notFoundRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'not-found',
	path: '',
});
